@if (lesson && (activities$ | async); as activities) {
  <div class="header">
    <ng-container *ngTemplateOutlet="headerTemplate; context: {$implicit: lesson}"></ng-container>
  </div>
  <div class="content">
    @for (activity of activities$ | async; track activity; let index = $index) {
      <ng-container
      *ngTemplateOutlet="activityTemplate; context: {activity, index: lessonIndex + '_' + index}"></ng-container>
    }
  </div>
} @else {
  <mat-spinner
  style="position:relative; display: flex; justify-content: center; align-items: center; height: 100%;"></mat-spinner>
}




